export {
    default,
    loader,
    LoadingFallback,
} from "~/components/product/ProductDetails/index"
import { Props } from "~/components/product/ProductDetails/index"
import { asResolved } from "@decocms/blocks/cms"

// `sync` so ProductDetails renders directly into the SSR shell instead of going
// through DecoPageRenderer's eager+React.lazy path. That path wraps the section
// in `<Suspense fallback={null}>` — it builds a `fallbackEl` from the exported
// `LoadingFallback` but only uses it on the `clientOnly` branch — so the shell
// shipped `<template id="B:4"></template>`, a 0px placeholder at y=217, and the
// ~1440px product block popped in at the end of the stream. Same fix and same
// reason as `SearchResult` on the PLP.
//
// No `neverDefer` needed here (unlike SearchResult): ProductDetails sits at
// index 4 on the PDP block, below `foldThreshold` (6, see src/setup.ts), so the
// position-based rule already keeps it in the eager pass.
export const sync = true;

/**
 * Tira as sections de 404 do caminho de resolução do CMS.
 *
 * `notFoundSections` só renderiza quando o produto NÃO existe, mas o resolver do
 * CMS é recursivo e resolve todo `__resolveType` que encontra nas props — então
 * o `ProductShelf` de fallback, cujo `products` é uma busca full-text por
 * "calcinha", rodava em TODA PDP e o resultado era jogado fora. Medido no
 * loader: 1135–1703ms do conjunto EAGER da PDP.
 *
 * `asResolved(v, true)` devolve um thunk e o resolver não caminha em `v`. O
 * loader chama `resolveDeferred` só quando `page` é null.
 */
export const onBeforeResolveProps = (props: Props) => ({
    ...props,
    notFoundSections: asResolved(props.notFoundSections, true),
});